import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 shadow-catering-xs" }
const _hoisted_2 = { class: "divide-y divide-catering-cream-300" }
const _hoisted_3 = { class: "min-w-0 truncate" }
const _hoisted_4 = {
  key: 0,
  class: "text-catering-berry-500"
}
const _hoisted_5 = { class: "shrink-0 tabular-nums" }


export default {
  __name: 'BotMenuList',
  props: { block: { type: Object, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Menu", -1)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.items || [], (item, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: _normalizeClass(["flex items-center justify-between py-1.5 text-sm", item.available === false ? 'text-catering-ink-400' : 'text-catering-ink-900'])
        }, [
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(item.name) + " ", 1),
            (item.available === false)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "· unavailable"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(item.price_formatted), 1)
        ], 2))
      }), 128))
    ])
  ]))
}
}

}